// frontend/src/components/ChangePassword.tsx
import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { buildApiUrl } from '../config/api';

const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    new_password2: ''
  });
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPassword2, setShowNewPassword2] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (formData.new_password !== formData.new_password2) {
      setError('הסיסמאות החדשות אינן תואמות');
      return;
    }

    if (formData.new_password.length < 8) {
      setError('הסיסמה החדשה חייבת להכיל לפחות 8 תווים');
      return;
    }

    setLoading(true);

    try {
      await axios.post(buildApiUrl('/users/auth/change-password/'), formData);
      
      setSuccess('הסיסמה שונתה בהצלחה!');
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (err: any) {
      if (err.response?.data?.details) {
        const details = err.response.data.details;
        if (details.old_password) {
          setError(details.old_password[0] || 'הסיסמה הישנה שגויה');
        } else if (details.new_password) {
          setError(details.new_password[0] || 'הסיסמה החדשה לא תקינה');
        } else {
          setError(err.response.data.error || 'שגיאה בשינוי סיסמה');
        }
      } else {
        setError(err.response?.data?.error || 'שגיאה בשינוי סיסמה');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: '600px', direction: 'rtl' }}>
      <Card>
        <Card.Header as="h3" className="text-center">
          שינוי סיסמה
        </Card.Header>
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>סיסמה נוכחית *</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showOldPassword ? 'text' : 'password'}
                  name="old_password"
                  value={formData.old_password}
                  onChange={handleChange}
                  required
                  disabled={loading || !!success}
                  autoComplete="current-password"
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowOldPassword(!showOldPassword)}
                  disabled={loading || !!success}
                >
                  {showOldPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                </Button>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>סיסמה חדשה * (לפחות 8 תווים)</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showNewPassword ? 'text' : 'password'}
                  name="new_password"
                  value={formData.new_password}
                  onChange={handleChange}
                  required
                  minLength={8}
                  disabled={loading || !!success}
                  autoComplete="new-password"
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  disabled={loading || !!success}
                >
                  {showNewPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                </Button>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>אימות סיסמה חדשה *</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showNewPassword2 ? 'text' : 'password'}
                  name="new_password2"
                  value={formData.new_password2}
                  onChange={handleChange}
                  required
                  minLength={8}
                  disabled={loading || !!success}
                  autoComplete="new-password"
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowNewPassword2(!showNewPassword2)}
                  disabled={loading || !!success}
                >
                  {showNewPassword2 ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                </Button>
              </InputGroup>
            </Form.Group>

            <div className="d-flex gap-2">
              <Button
                variant="primary"
                type="submit"
                className="flex-grow-1"
                disabled={loading || !!success}
              >
                {loading ? 'משנה...' : 'שנה סיסמה'}
              </Button>
              <Button
                variant="secondary"
                onClick={() => navigate('/')}
                disabled={loading}
              >
                ביטול
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ChangePassword;
